import React from 'react'
import {Text} from '@miro-site/core'

interface Props {
  children: React.ReactNode
}

const Description: React.FC<Props> = ({children}) => {
  return (
    <Text $styles={{color: 'var(--wcds-onboarding-description-text-color)'}} $variant="p2">
      {children}
    </Text>
  )
}

export default Description
